import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withAlert } from 'react-alert';
import isEmpty from 'lodash/isEmpty';
import * as _ from 'lodash';
import Dropdown from 'react-dropdown';
// import { toast } from 'react-toastify';
import MaskInputNumber from '../../common/maskInputNumberProfile';

import 'react-toastify/dist/ReactToastify.css';
import loader from '../../../images/Spin-1s-107px.gif';


import TextFieldGroup from '../../common/TextFieldGroupProfile';
import { getAffiliateSubUserById, getAllCountry, UpdateAffiliateSubUser, getAffiliateUser, receiveUpdateAffiliateSubUserClear } from '../../../Actions/actions';
// import SideMenu from '../../sideMenu/sideMenu';


class SubuserUpdateAffiliate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      firstname: '',
      lastname: '',
      phone: '',
      password: '',
      countryCode: '+1',
      affiliateSubUserId: '',
      cognitoUserId: '',
      errors: {},
      isLoading: false,
      failedLoginMessages: '',
      affiliateSubUserUpdatedData1: [],
      updateProfileAState: false,
      isLoader: false,
      isprofileStatus: this.props.isprofile
    };
    this.onChange = this.onChange.bind(this);
    this.handleSubUsers = this.handleSubUsers.bind(this);
    this._countrySelect = this._countrySelect.bind(this);
    this.closeCompanyUserSub = this.closeCompanyUserSub.bind(this);
  }

  onChange(e) {
    this.setState({ errors: {}, isLoading: true, failedLoginMessages: '' });
    this.setState({ [e.target.name]: e.target.value });
  }

  closeCompanyUserSub() {
    this.context.router.history.push('/profile');
  }

  _countrySelect(e) {
    this.setState({ countryCode: e.value });
  }

  handleSubUsers(e) {
    e.preventDefault();
    if (this.isValid()) {
      this.setState({ errors: {}, isLoader: true, updateProfileAState: true });
      this.props.UpdateAffiliateSubUser(this.state);
      // this.setState({email: '',firstname: '',lastname: '',phone: '',password: ''});
    }
  }

  isValid() {
    const { errors, isValid } = this.validateInput(this.state);
    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }

  validateInput(data) {
    const errors = {};

    // console.log("data",data)

    if (!data.firstname) {
      errors.firstName = 'First name is required';
      errors.firstNameError = true;
    } else if (data.firstname.length < 2 || data.firstname.length > 20) {
      errors.firstName = 'First name should be between 2 to 20 characters';
      errors.firstNameError = true;
    }
    if (!data.lastname) {
      errors.lastname = 'Last name is required';
      errors.lastNameError = true;
    } else if (data.lastname.length < 2 || data.lastname.length > 20) {
      errors.lastname = 'Last name should be between 2 to 20 characters';
      errors.lastNameError = true;
    }
    if (!data.phone) {
      errors.phone = 'Mobile number is required';
      errors.newMobilePhoneError = true;
    } else if (data.phone.replace(/\s/g, '').replace(/[_-]/g, '').length !== 10) {
      errors.phone = 'Please enter at least 10 digit';
      errors.newMobilePhoneError = true;
    }

    return {
      errors,
      isValid: isEmpty(errors),
    };
  }

  componentWillMount() {
    this.props.getAffiliateSubUserById({ affiliateSubUserId: this.props.subUserId });
    this.props.getAllCountry();
  }

  componentWillUnmount () {
    const {receiveUpdateAffiliateSubUserClear} = this.props
    receiveUpdateAffiliateSubUserClear()
  }


  componentDidUpdate() {
    const { affiliateSubUserUpdatedData } = this.props.data;
    const { affiliateSubUserUpdatedData1 } = this.state;
      if (affiliateSubUserUpdatedData !== undefined) {
        if (affiliateSubUserUpdatedData1 !== affiliateSubUserUpdatedData) {
          this.setState({
            affiliateSubUserUpdatedData1: affiliateSubUserUpdatedData,
            updateProfileAState: false,
            isLoader: false,
          }, async () => {
            if(affiliateSubUserUpdatedData.code === 200) {
              await this.props.getAffiliateUser(localStorage.getItem('userId'));
              await this.context.router.history.push('/profile');
              }
 
          });
        }
      }
    }
  


  componentWillReceiveProps(nextProps) {
    // console.log(nextProps.affiliateSubUserUpdatedData);
    const { affiliateSubUserUpdatedDataR } = this.state;
    const receivedUserById = nextProps.data.affiliateSubUserDataById;
    if (affiliateSubUserUpdatedDataR !== receivedUserById) {
      this.setState({
        email: receivedUserById.email,
        firstname: receivedUserById.firstName,
        lastname: receivedUserById.lastName,
        phone: receivedUserById.phoneNumber,
        countryCode: receivedUserById.countryCode,
        affiliateSubUserId: receivedUserById.affiliateSubUserId,
        cognitoUserId: receivedUserById.cognitoId,
        affiliateSubUserUpdatedDataR: receivedUserById,
      });
    }
  }

  render() {
    const {
      errors, isLoader, firstname, lastname, phone, countryCode, email
    } = this.state;
    const { AllCountryData } = this.props.data;
    const { isprofile } = this.props
    const optionsCountry = [];
    if (AllCountryData !== undefined) {
      AllCountryData.map(item => optionsCountry.push({ value: item.countryCode, label: item.countryCode, name: item.countryCode }));
    } else {
      optionsCountry.push({ value: '+1', label: '+1', name: '+1' });
    }
    const cSelectedCountry = _.find(optionsCountry, { value: countryCode });
    const cDefaultOptionCountry = cSelectedCountry;
    let loader1;
    if (isLoader) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }

    return (
      <span>
        {loader1}
        <div>

          <div className="main-content shadow-none">
            <div className="row">
              <div className="tab-inner">
              <div className="col s12">
                <div className="welcome-partner">
                  <div className="col s12">
                    <h5 className="tab-heading col s12 blue-heading">{isprofile ? "Account Information" : "Edit sub user"}</h5>
                    <form className="col s12" onSubmit={this.handleSubUsers}>
                      <div className="row profile-formmain">
                        <div className="input-field col s6">
                          <TextFieldGroup
                            field="firstname"
                            label="First Name*"
                            value={firstname}
                            error={errors.firstName}
                            onChange={this.onChange}
                          />

                        </div>

                        <div className="input-field col s6">
                          <TextFieldGroup
                            field="lastname"
                            label="Last Name*"
                            value={lastname}
                            error={errors.lastname}
                            onChange={this.onChange}
                          />

                        </div>
                        <div className=" col s12 phone-signupnew">
                          <div className="input-field col s4 input-field tel-input-lt" style={{ paddingLeft: 0 }}>
                            <label className="active country-code">Country Code</label>
                            <Dropdown
                              name="cState"
                              className="browser-default"
                              options={optionsCountry}
                              onChange={this._countrySelect}
                              value={cDefaultOptionCountry}
                              placeholder="Select an option"
                            />
                            <span className={errors.countryCodeError ? 'show invalid' : 'hide'}>{errors.countryCode}</span>

                          </div>

                          <div className="col s8 input-field tel-input-rt">
                            <MaskInputNumber
                              field="phone"
                              label="Phone number*"
                              value={phone}
                              error={errors.phone}
                              onChange={this.onChange}
                            />
                          </div>

                          {isprofile ? ( <div className="input-field col s12">
                            <TextFieldGroup
                              field="email"
                              label="Email Id*"
                              value={email}
                              disable
                            />
                          </div>
                         ) : ""}
                        </div>

                      </div>
                      <div className="btn-outer">
                          <button type="submit" name="action" className="btn waves-effect waves-light primary-btn col s8 offset-s3 primary-btn-new">
                          {isprofile ? "Update" : "Update Sub User"}
                            {' '}
                          </button>
                          {!isprofile ? (  <button onClick={this.closeCompanyUserSub} type="submit" name="action" className="btn waves-effect waves-light primary-btn col s8 offset-s3 primary-btn-new">
Cancel
                            {' '}
                          </button>) : ""}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

SubuserUpdateAffiliate.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getAffiliateSubUserById, getAllCountry, UpdateAffiliateSubUser, getAffiliateUser, receiveUpdateAffiliateSubUserClear }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(SubuserUpdateAffiliate));
